import ThisModule from "./AvailabilityTable";

export default ThisModule;
